module.exports = __webpack_public_path__ + "static/img/banner4.e7f968e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad/banner4.png
// module id = 9+7G
// module chunks = 1